module.exports = __webpack_public_path__ + "img/index_header_logo.1cb99111.png";